module.exports = __webpack_public_path__ + "img/electronic_electric_reserved.bd28fbca.svg";